export default __webpack_public_path__ + "static/media/swansea-university-logo-color.03d2bf74.svg";